// @ts-nocheck
import getShowInventory from "@store/Framework/Common/Utilities/getShowInventory";
import convertSelectorToHooks from "@toolkit/Framework/Common/Utilities/convertSelectorToHook";

const useShowInventory = convertSelectorToHooks(getShowInventory);

export default useShowInventory;
